import { render } from "./AiAssistanceCard.vue?vue&type=template&id=1f06a5a3&scoped=true"
import script from "./AiAssistanceCard.vue?vue&type=script&lang=js"
export * from "./AiAssistanceCard.vue?vue&type=script&lang=js"

import "./AiAssistanceCard.vue?vue&type=style&index=0&id=1f06a5a3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f06a5a3"]])

export default __exports__